import { createApp } from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import router from './router';
import './assets/tailwind.css';
import './assets/styles.css';
import Vuelidate from '@vuelidate/core';

const app = createApp(App);
app.use(router);
app.use(Vuelidate);
app.use(vuetify);

app.mount('#app');
